/* MULLIWEN theme script: overlays, header, cart, product options, gallery, search, wishlist, popup. No dependencies. */
(function () {
  'use strict';
  var R = (window.MW && window.MW.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', predictive: '/search/suggest' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function money(cents) {
    var fmt = (window.MW && window.MW.moneyFormat) || '£{{amount}}';
    var n = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
  }

  /* ---------- overlays ---------- */
  var openStack = [];
  function focusables(el) { return $$('a[href],button:not([disabled]):not([tabindex="-1"]),input:not([type=hidden]),select,textarea,[tabindex="0"]', el).filter(function (n) { return n.offsetParent !== null; }); }
  function openOverlay(id, trigger) {
    var el = document.getElementById(id); if (!el) return false;
    $$('[data-overlay]:not([hidden])').forEach(function (o) { if (o !== el) closeOverlay(o, true); });
    el.hidden = false; el._trigger = trigger || document.activeElement; openStack.push(el);
    document.body.classList.add('locked');
    var f = $('[autofocus], input[type=search], input[type=email]', el) || $('.x', el) || focusables(el)[0];
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
    if (el.hasAttribute('data-popup')) badge(false);
    el.dispatchEvent(new CustomEvent('overlay:open'));
    return true;
  }
  function closeOverlay(el, silent) {
    if (!el || el.hidden) return;
    el.hidden = true; openStack = openStack.filter(function (o) { return o !== el; });
    if (!openStack.length) document.body.classList.remove('locked');
    if (el.hasAttribute('data-popup')) { popSeen(el); badge(true); }
    if (!silent && el._trigger && document.body.contains(el._trigger)) el._trigger.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) { if (openOverlay(op.getAttribute('data-open'), op)) e.preventDefault(); return; }
    var cl = e.target.closest('[data-close]');
    if (cl) { e.preventDefault(); closeOverlay(cl.closest('[data-overlay]')); return; }
    var acc = e.target.closest('[data-acc]');
    if (acc) {
      var p = document.getElementById(acc.getAttribute('aria-controls'));
      var openNow = acc.getAttribute('aria-expanded') !== 'true';
      acc.setAttribute('aria-expanded', openNow); if (p) p.hidden = !openNow;
      return;
    }
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      var list = tab.parentNode;
      $$('[data-tab]', list).forEach(function (t) {
        var on = t === tab; t.setAttribute('aria-selected', on);
        var pnl = document.getElementById(t.getAttribute('aria-controls')); if (pnl) pnl.hidden = !on;
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    var top = openStack[openStack.length - 1]; if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); closeOverlay(top); return; }
    if (e.key === 'Tab') {
      var f = focusables(top); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  $$('[role=tablist]').forEach(function (list) {
    list.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tabs = $$('[data-tab]', list), i = tabs.indexOf(document.activeElement); if (i < 0) return;
      var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); n.click();
    });
  });

  /* ---------- header: height, see-through over first image ---------- */
  var hdr = $('[data-header]');
  var hero = $('#main > .shopify-section:first-child [data-hero]');
  var see = hdr && hdr.getAttribute('data-transparent') === 'true' && !!hero;
  if (!see) document.body.classList.add('hdr-solid');
  function setHdr() { if (hdr) document.documentElement.style.setProperty('--hdr', hdr.offsetHeight + 'px'); }
  function headerState() { if (hdr) hdr.classList.toggle('over', see && hero.getBoundingClientRect().bottom > hdr.offsetHeight + 8); }
  var hideOn = hdr && hdr.getAttribute('data-hide-scroll') === 'true', hdrSec = hdr && hdr.closest('.shopify-section'), lastY = window.scrollY;
  function hideState() {
    if (!hideOn || !hdrSec) return;
    var y = window.scrollY, down = y > lastY && y > hdr.offsetHeight * 3;
    if (Math.abs(y - lastY) > 4) { hdrSec.classList.toggle('hdr-hidden', down && !document.body.classList.contains('locked')); lastY = y; }
  }
  setHdr(); headerState();
  window.addEventListener('scroll', function () { headerState(); hideState(); }, { passive: true });
  window.addEventListener('resize', function () { setHdr(); headerState(); });

  /* ---------- country selector ---------- */
  $$('[data-country]').forEach(function (b) {
    b.addEventListener('click', function () { var i = $('[data-country-input]'); if (i) i.value = b.getAttribute('data-country'); });
  });

  /* ---------- sort auto-submit ---------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- cart ---------- */
  function renderCart(sections) {
    var html = sections && sections['cart-drawer']; if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer]', doc), cur = $('[data-cart-drawer]');
    if (fresh && cur) { var wasOpen = !cur.hidden; cur.innerHTML = fresh.innerHTML; cur.hidden = !wasOpen; }
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-cart-dot]').forEach(function (el) { el.hidden = !n; });
  }
  function refreshCount() { fetch(R.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-drawer] [data-line]'); if (!b) return;
    e.preventDefault();
    fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.getAttribute('data-line'), quantity: +b.getAttribute('data-qty'), sections: ['cart-drawer'] }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c.sections); setCount(c.item_count); var x = $('[data-cart-drawer] .x'); if (x) x.focus(); })
      .catch(function () { window.location = R.cart; });
  });

  /* ---------- product ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = root.parentNode.querySelector('[data-product-json]'); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = document.getElementById(root.getAttribute('data-form'));
    var input = $('[data-variant-input]', root), btn = $('[data-atc]', root), label = $('[data-atc-label]', root), price = $('[data-price]', root), hint = $('[data-hint]', root);
    var current = product.variants.filter(function (v) { return String(v.id) === input.value; })[0] || product.variants[0];
    var selected = current ? current.options.slice() : [];
    var colourIdx = -1;
    product.options.forEach(function (o, i) { if (/colou?r/i.test(o.name || o)) colourIdx = i; });

    function find() { return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0]; }
    function update(push) {
      var v = find();
      $$('[data-option]', root).forEach(function (b) {
        var i = +b.getAttribute('data-option'), val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', selected[i] === val);
        if (colourIdx > -1 && i !== colourIdx) {
          var ok = product.variants.some(function (x) { return x.available && x.options[i] === val && x.options[colourIdx] === selected[colourIdx]; });
          b.classList.toggle('na', !ok);
        }
      });
      $$('[data-option-label]', root).forEach(function (l) { l.textContent = selected[+l.getAttribute('data-option-label')]; });
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
      input.value = v.id; price.textContent = money(v.price);
      btn.disabled = !v.available; label.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (hint) hint.textContent = '';
      if (push) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      filterGallery();
    }
    function filterGallery() {
      if (colourIdx < 0) return;
      var items = $$('.g-item', root); if (!items.length) return;
      var names = (product.options_with_values ? product.options_with_values[colourIdx].values : product.variants.map(function (v) { return v.options[colourIdx]; }))
        .map(function (n) { return String(n).toLowerCase(); });
      var want = String(selected[colourIdx] || '').toLowerCase();
      var hits = items.filter(function (it) { return it.getAttribute('data-key').indexOf(want) > -1; });
      if (!hits.length) hits = items.filter(function (it) { var k = it.getAttribute('data-key'); return !names.some(function (n) { return n !== want && k.indexOf(n) > -1; }); });
      if (!hits.length) hits = items;
      items.forEach(function (it) { it.hidden = hits.indexOf(it) < 0; });
      gallery.reset();
    }
    $$('[data-option]', root).forEach(function (b) {
      b.addEventListener('click', function () { selected[+b.getAttribute('data-option')] = b.getAttribute('data-value'); update(true); });
    });

    var gal = $('[data-gallery]', root), n = $('[data-gal-n]', root), prog = $('[data-gal-prog]', root);
    var gallery = {
      visible: function () { return $$('.g-item', gal).filter(function (i) { return !i.hidden; }); },
      reset: function () {
        var v = gallery.visible(); if (gal) gal.scrollLeft = 0;
        if (prog) prog.innerHTML = v.map(function (_, i) { return '<span' + (i === 0 ? ' class="on"' : '') + '></span>'; }).join('');
        if (n) n.textContent = v.length ? '1/' + v.length : '';
      }
    };
    if (gal) gal.addEventListener('scroll', function () {
      var v = gallery.visible(), i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      if (n) n.textContent = (i + 1) + '/' + v.length;
      if (prog) $$('span', prog).forEach(function (s, j) { s.className = j === i ? 'on' : ''; });
    }, { passive: true });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!find()) { if (hint) hint.textContent = 'Select a size.'; return; }
      btn.disabled = true;
      var fd = new FormData(form); fd.append('sections', 'cart-drawer');
      fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { if (hint) hint.textContent = res.j.description || res.j.message || 'This piece could not be added.'; return; }
          renderCart(res.j.sections); refreshCount(); openOverlay('CartDrawer', btn);
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
    update(false);
  });

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'), f = $('[data-recs]', d);
      if (f && f.innerHTML.trim()) { el.innerHTML = f.innerHTML; syncHearts(); }
    }).catch(function () {});
  });

  /* ---------- predictive search ---------- */
  var sIn = $('[data-predictive]'), sOut = $('[data-predictive-results]'), sT;
  if (sIn && sOut) sIn.addEventListener('input', function () {
    clearTimeout(sT); var q = sIn.value.trim();
    if (!q) { sOut.innerHTML = ''; return; }
    sT = setTimeout(function () {
      fetch(R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          sOut.innerHTML = ps.length ? ps.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img class="m-img" src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=500" alt="" loading="lazy">' : '';
            return '<div class="pc"><a class="pc-img" href="' + p.url + '"><span class="ph a">' + img + '</span></a><div class="pc-t"><a class="pc-n" href="' + p.url + '">' + p.title + '</a><span class="pc-p">' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></div></div>';
          }).join('') : '<p class="g pad">No results for “' + q.replace(/</g, '&lt;') + '”.</p>';
        }).catch(function () {});
    }, 200);
  });

  /* ---------- wishlist (stored in this browser) ---------- */
  function wishes() { return store('mw-wish') || []; }
  function syncHearts() {
    var w = wishes();
    $$('[data-wish]').forEach(function (b) { var on = w.indexOf(b.getAttribute('data-wish')) > -1; b.setAttribute('aria-pressed', on); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = w.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), w = wishes(), i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else w.push(h);
    store('mw-wish', w); syncHearts();
  });
  var acct = document.getElementById('AccountDrawer');
  if (acct) acct.addEventListener('overlay:open', function () {
    var list = $('[data-wish-list]', acct), w = wishes(); if (!list) return;
    if (!w.length) { list.innerHTML = '<p class="g">Tap the heart on any piece to save it here.</p>'; return; }
    Promise.all(w.map(function (h) { return fetch(R.root.replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        list.innerHTML = ps.filter(Boolean).map(function (p) {
          var img = p.featured_image ? '<img class="m-img" src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '';
          return '<div class="pc"><a class="pc-img" href="' + p.url + '"><span class="ph a">' + img + '</span></a><div class="pc-t"><a class="pc-n" href="' + p.url + '">' + p.title + '</a><button type="button" class="heart" data-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove from wishlist"><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.6 4.3 4.3 0 0 1 19.5 10C19.5 15.4 12 20 12 20z"/></svg></button><span class="pc-p">' + money(p.price) + '</span></div></div>';
        }).join('');
      });
  });
  syncHearts();

  /* ---------- forms posted: reopen the right overlay ---------- */
  var hash = window.location.hash.replace('#', '');
  if (hash === 'ContactOverlayForm') openOverlay('ContactOverlay');
  if (hash === 'PopupNewsletter') openOverlay('NewsletterPopup');

  /* ---------- newsletter popup ---------- */
  function badge(on) { var b = $('[data-pop-badge]'); if (b) b.hidden = !on; }
  function popSeen(p) {
    var mode = p.getAttribute('data-once');
    if (mode === 'session') { try { sessionStorage.setItem('mw-popup-seen', '1'); } catch (e) {} }
    else if (mode === 'ever') store('mw-popup-seen', 1);
  }
  function popWasSeen(p) {
    var mode = p.getAttribute('data-once');
    if (mode === 'always') return false;
    if (mode === 'session') { try { return !!sessionStorage.getItem('mw-popup-seen'); } catch (e) { return false; } }
    return !!store('mw-popup-seen');
  }
  var pop = $('[data-popup]');
  var design = !!(window.Shopify && window.Shopify.designMode);
  if (pop && design) {
    if (pop.getAttribute('data-editor-open') === 'true') openOverlay('NewsletterPopup', null);
  } else if (pop && popWasSeen(pop)) {
    badge(true);
  } else if (pop && hash !== 'PopupNewsletter' && (pop.getAttribute('data-mobile') !== 'false' || window.innerWidth > 760)) {
    setTimeout(function () { if (!openStack.length) openOverlay('NewsletterPopup', null); }, (+pop.getAttribute('data-delay') || 5) * 1000);
  }
  if (design) {
    document.addEventListener('shopify:section:load', function (e) { var p = e.target.querySelector('[data-popup]'); if (p && p.getAttribute('data-editor-open') === 'true') openOverlay('NewsletterPopup', null); });
    document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('[data-popup]')) openOverlay('NewsletterPopup'); });
    document.addEventListener('shopify:section:deselect', function (e) { var p = e.target.querySelector('[data-popup]'); if (p && p.getAttribute('data-editor-open') !== 'true') closeOverlay(p, true); });
  }
  window.MW = window.MW || {};
  window.MW.openOverlay = openOverlay; window.MW.closeOverlay = closeOverlay;

  /* ---------- password page ---------- */
  var pw = $('[data-pw]'); if (pw && $('.pw-err', pw)) pw.open = true;
})();
